/**
 * Auh Action Types
 * @type {string}
 */
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const SET_FORM = "SET_FORM";


